import { useEffect, useRef, useState } from 'react'
import usePayrollEssentials from 'hooks/usePayrollEssentials';
import { deletePayGroupEmployee, getPayGroupEmployees, savePayGroupEdits, togglePayGroupEmployeeAssignment } from 'store/entities/payroll/payrollSetup/action';
import { ReactComponent as AddIcon } from "assets/images/icons/add.svg";
import { ReactComponent as EditIcon } from "assets/images/icons/edit.svg"
import PayGroupEmployeeAssignmentModal from './PayGroupEmployeeAssignmentModal';
import { ButtonLoader } from 'components/__new/common/form';
import Table from 'components/__new/common/Table';
import Spinner from 'components/__new/common/Spinner';
import BulkActionHandler from 'components/__new/common/BulkActionHandler';
import DialogBox from 'utils/dialogBox';
import { toast } from 'react-toastify';
import { useLocation } from 'react-router-dom';
import { getAllEmployees } from 'store/entities/employees/action';
import Maybe from 'components/__new/common/Maybe';
import Pagination from 'components/__new/common/pagination';
import useUrlQueryParams from 'hooks/useUrlQueryParams';
import processParams from 'utils/processParams';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ViewPayGroupDetails = () => {
    const location = useLocation()
    const submitRef = useRef(null)
    const {useSelector, dispatch, history, truncator, lettersRegex} = usePayrollEssentials();

    const { editPayGroupLoading: editLoading, payGroupStaffLoading, payGroupStaffData } = useSelector(state => state.entities.payrollSetup)
    const [current, setCurrent] = useState(0);
    const [form, setForm] = useState({});
    const {urlQueryParams} = useUrlQueryParams();
    const payload = location?.state?.payload;

    // eslint-disable-next-line
    const [bulkDeleting, setBulkDeleting] = useState(false);
    const [isViewing, setIsViewing] = useState(true);
    const [listParams, setListParams] = useState({ "page": 1, "limit": 10, id: payload?.id });

    const [batch, setBatch] = useState([]);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const employeesValid = payGroupStaffLoading === false && payGroupStaffData?.data?.length > 0
    const toggleModal = () => dispatch(togglePayGroupEmployeeAssignment())
    const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen)

    const staff = payGroupStaffData?.data;
    const allEmployeeIDs = staff?.map(item => item.id) || [];

    const fetchPaygroupEmployees = () => {
        let params = {...listParams};

        params = processParams(urlQueryParams, params, "page", "number", 1, "page");
        params = processParams(urlQueryParams, params, "limit", "number", 10, "limit");

        setListParams(params);
        dispatch(getPayGroupEmployees(params));
    }

    const handleSubmit = () => {

        if(!form?.name || form?.name?.length < 3) {
            toast.error('Please enter a pay group name with at least 3 letters');
            setCurrent(0);
        } else if (!lettersRegex.test(form?.name)) {
            toast.error('Pay group name must contain letters');
            setCurrent(0);
        }  else {
            dispatch(savePayGroupEdits(form)).then(() => history.push("/payroll-configuration/pay-groups"))
        }
    }

    const handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value
        setForm({...form, [name]: value})
    }

    const toggleSingleItem = (id) => {
        const alreadyExists = batch?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = batch?.filter(item => item !== id)
            setBatch(filtered)
        } else {
            setBatch([...batch, id])
        }
    }

    const toggleEntireList = () => {
        if (batch.length !== allEmployeeIDs?.length) {
            setBatch(allEmployeeIDs)
        } else {
            setBatch([])
        }
    }

    const dispatchDelete = (payload) => dispatch(deletePayGroupEmployee(payload)).then(() => {
            toggleDeleteModal();
            setTimeout(() => {
                dispatch(getAllEmployees({page: 1}));
                dispatch(getPayGroupEmployees({id: payload?.id}));
            }, 1500)
        })

    const handleSingleDelete = async (item) => {
        const result = await DialogBox({
			title: "Delete Employee 😰",
			content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{truncator(item.firstName + " " + item.lastName)}</span>? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            const items = {id: payload?.id, employee_ids: [item.id]};
            dispatchDelete(items).then(() => setBatch([]))
        }
    }

    const handleBulkDelete = async () => {
        const result = await DialogBox({
			title: "Delete Employees 😰",
			content: <div className="delete-modal-text">Are you sure you want to delete <span className="delete-modal-highlight">{batch?.length} {batch?.length > 1 ? "Employees" : "Employee"} </span>? This action cannot be undone.</div>,
			buttonYes: "Delete",
            buttonYesClass: "btn-ep-red",
			buttonNo: "Cancel",
		});
		if (result) {
            const items = {id: payload?.id, employee_ids: batch};
            dispatchDelete(items).then(() => setBatch([]))
        }
    }

    const items = [
        {title: "Pay Group Details", Component: (
            <div className="w-full">
                <form onSubmit={handleSubmit} className="w-full">
                    <div className="w-full pt-7 lg:pt-0">
                        <div className="mb-5">
                            <p className="structure-text">Name of Pay Group</p>
                            <div className="mt-2">
                                <input minLength={3} maxLength={50} disabled={isViewing} className="form-input" type="text" name='name'
                                value={form?.name || ""} onChange={(e) => setForm({...form, name: e.target.value})} />
                            </div>
                        </div>

                        <div className="">
                            <p className="structure-text">Description of Pay Group</p>
                            <div className="mt-2">
                                <textarea disabled={isViewing} style={{resize: "none"}} value={form?.description || ""} rows="6" className="form-input-textarea"
                                    placeholder='Enter description' onChange={handleChange} name='description' />
                            </div>
                        </div>
                        <button ref={submitRef} style={{display: 'none'}} type="submit">Continue</button>
                    </div>
                </form>
            </div>
        )},
        {title: "Pay Group List", Component: (
            <div className="w-full">
                {payGroupStaffLoading ? <div className="flex items-center justify-center">
                    <Spinner message="Fetching Employees" />
                </div> : employeesValid ?
                <div>
                    <div className="flex items-center justify-end pb-5">
                        {!isViewing && <button disabled={batch?.length > 1 || editLoading} onClick={toggleModal} className="flex items-center btn btn-md btn-transparent-primary font-medium">
                            <AddIcon className='mr-3' />  Add Employee
                        </button>}
                    </div>
                    {batch?.length > 1 && <div className="pb-8">
                        <BulkActionHandler count={batch?.length} onCancel={() => {
                            setBatch([]);
                        }} onDelete={() => {
                            setBulkDeleting(true);
                            handleBulkDelete();
                        }} />
                    </div>}
                    <Table>
                            <Table.Head>
                                <th>
                                    <div className="flex items-center">
                                        {!isViewing && <input onChange={toggleEntireList}
                                        type="checkbox" className="w-5 h-5 form-checkbox float-left"
                                        checked={batch?.length === allEmployeeIDs?.length} />}
                                        <p className={`mb-0 ${!isViewing && 'ml-4'}`}>Name of Employee</p>
                                    </div>
                                </th>
                                <th>Email Address</th>
                                <th>Action</th>
                            </Table.Head>
                            <Table.Body>
                                {staff?.map((item, idx) => {
                                    return <tr key={idx}>
                                            <td>
                                                <div className="flex items-center">
                                                    {!isViewing && <input value={item.id} onChange={() => toggleSingleItem(item.id)}
                                                    checked={batch?.includes(item.id)}
                                                    type="checkbox" className="w-5 h-5 mr-4 form-checkbox float-left" />}
                                                    <p className="mb-0 capitalize">
                                                        {item.firstName.toLowerCase() + " " + item.lastName.toLowerCase()}
                                                    </p>
                                                </div>
                                            </td>
                                                <td>
                                                <p className="mb-0 lt-gray">
                                                    {item.email}
                                                </p>
                                            </td>
                                            <td>
                                                <button disabled={isViewing} onClick={() => {
                                                    setBulkDeleting(false);
                                                    handleSingleDelete(item);
                                                }} className={`${isViewing ? "cursor-not-allowed text-[#e5e7eb] text-opacitys-20" : "text-ep-danger"}`}>Remove Employee</button>
                                            </td>
                                        </tr>
                                        }
                                    )}
                            </Table.Body>
                        </Table>

                        <Maybe condition={payGroupStaffLoading === false && payGroupStaffData?.data?.length > 0}>
                            <div className="mt-6">
                                <Pagination data={payGroupStaffData?.pageInfo} />
                            </div>
                        </Maybe>
                </div>
                        :
                <div className="w-full flex items-center justify-center flex-col">
                    
                    <div className="px-2 pt-10 pb-5 text-center m-auto text-gray-500">
                        <FontAwesomeIcon className='text-4xl mb-2' icon="list" />
                        <div className="font-semibold uppercase">
                            No Results Found
                        </div>
                    </div>
                    
                    <Maybe condition={!isViewing}>
                        <button disabled={editLoading} onClick={toggleModal} className="flex items-center btn btn-md btn-transparent-primary font-medium">
                            <AddIcon className='mr-3' />  Add Employee
                        </button>
                    </Maybe>
                </div>}
            </div>
        )}
    ]

    useEffect(() => {
        if(payload?.name?.length) {
            setForm(payload)
        } else {
            history.push("/payroll-configuration/pay-groups")
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        setBatch([])
        fetchPaygroupEmployees()
        // eslint-disable-next-line
    }, [location])

    return (
    <div className="w-full">

        <PayGroupEmployeeAssignmentModal
            setCurrent={setCurrent}
            selectedPayGroup={payload}
            toggleModal={toggleModal}
        />

        <div className="flex-btw items-center flex-wrap lg:flex-nowrap pb-3 lg:pb-0">
            <div className="w-full lg:w-2/4 mb-5 lg:mb-0">
                <p className="mb-0 font-medium prl-bold capitalize">{isViewing ? "View" : "Edit"} "{form?.name?.toLowerCase()}" Pay Group</p>
            </div>
            <div className="w-full lg:w-2/4 flex items-center lg:justify-end">
                <ButtonLoader loading={editLoading} onClick={() => isViewing ? setIsViewing(!isViewing) : handleSubmit()} className="btn btn-md btn-ep-primary mr-4 lg:mr-6">
                    {isViewing ?
                        <span className='flex items-center pr-3'>
                            <EditIcon className='mr-3' /> Edit
                        </span> : editLoading ? "Submitting..." : "Update Details"}
                </ButtonLoader>

                <button
                    disabled={editLoading}
                    onClick={() => history.push("/payroll-configuration/pay-groups")}
                    className="btn btn-md btn-transparent-primary">
                    Cancel
                </button>
            </div>
        </div>
        <div className="bg-white p-5 mt-7 lg:mt-10 rounded-md">
                <div className='w-full pt-4'>
                    <div className="w-full flex border-b pb-2">
                    {items.map(({title}, idx) => {
                    const isActive = current === idx
                    return <div onClick={() => setCurrent(idx)} key={idx} className={`mr-6 text-sm cursor-pointer ${isActive ? 'relative text-ep-primary-600 font-medium' : 'text-[#7a8096]'}`}>
                            <p className="mb-0">{title}</p>
                            {isActive && <div style={{height: '2px', bottom: '-8px'}} className='absolute w-full left-0 bg-ep-primary-600' />}
                    </div>
                    })}
                    </div>
                </div>
                <div className={`mt-5 w-full ${current === 1 ? "w-full" : "lg:w-3/5"}`}>{items[current].Component}</div>
        </div>
    </div>
    )
}

export default ViewPayGroupDetails